<template>
    <div class="row" style="margin:20px;">
        <l-map
            ref="leafmap"
            :options="mapOptions"
            style="height: 50vh; border-radius: 10px;"
            @ready="updateRaster()"
        >
            <l-tile-layer :url="url" :attribution="attribution" />
            <l-geo-json ref="leafgeojson" :geojson="values" :options="geojsonOptions" v-if="mapType === 'rawMap'"></l-geo-json>
            <l-feature-group ref="features" :parcel="parcel" :carac="carac" :sextiles="sextiles" :visible="mapType === 'interpolatedMap'" :min="min" :max="max"></l-feature-group>
        </l-map>
    </div>
</template>
<script>

import { circleMarker } from "leaflet";
import { LMap, LTileLayer, LGeoJson, LFeatureGroup } from "vue2-leaflet";
import GeoRasterLayer from 'georaster-layer-for-leaflet';
import * as helpers from '../helpers.js'

export default {
    name: 'MapComponent',
    components:{
        LMap,
        LTileLayer,
        LGeoJson,
        LFeatureGroup
    },

    props:{
        carac:String,
        mapType:String,
        parcel:Object,
        sextiles:Array,
        values:Array,
        min:Number,
        max:Number
    },

    mounted(){
        this.centerMap();
    },

    data() {
        return {
            animate: true,
            url: "https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}",
            attribution: "Tiles &copy; Esri &mdash; Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community",
            mapOptions: {
                zoomSnap: 0.5,
            },
            georasterLayer: null,
        }
    },

    computed:{

        geojsonOptions: function(){
            var self = this;
            var carac = this.carac;
            var sextiles = this.sextiles;
            return {
                onEachFeature: function (feature, layer) {
                    if (feature.properties && feature.properties[carac]) {
                        layer.bindPopup(feature.properties[carac].toLocaleString(navigator.language));
                        layer.on('mouseover', () => { layer.openPopup(); });
                        layer.on('mouseout', () => { layer.closePopup(); });
                    }
                },
                pointToLayer: function (feature, latlng) {
                    return circleMarker(latlng, {
                        radius: 3,
                        fillColor: self.getColor(feature.properties[carac], sextiles),
                        weight: 0,
                        fillOpacity: 1
                    });
                },
            }
        },

        tiff () {
            return this.parcel.tiff[this.carac]
        }
    },

    created() {
    },

    updated() {
        if (this.mapType == 'interpolatedMap')
            this.updateRaster();
        this.centerMap();
    },

    methods: {
        async updateRaster() {
            if (this.georasterLayer !== null){
                try {
                    this.$refs.features.mapObject.removeLayer(this.georasterLayer);
                } catch (error) {
                    console.log('cannot remove layer');
                }
            }
            if (!this.tiff) return null
            console.log('tiff update', this.tiff.values[0][56])
            console.log('min', this.min)
            this.georasterLayer = new GeoRasterLayer({
                georaster: this.tiff,
                pixelValuesToColorFn: values => {
                    let nir = values[0];
                    // HACK density to purcent
                    if (this.carac ==='tfi') nir =nir*100
                    if (isNaN(nir) || nir < this.min || nir > this.max)
                        return;
                    return this.getColor(nir, this.sextiles)
                    },
                opacity: 0.7,
                resolution: 256,
                noWrap: false 
            });

            this.georasterLayer.addTo(this.$refs.features.mapObject);
            this.georasterLayer.vShow = this.mapType === 'interpolatedMap';
        },

        centerMap(){
            const interval = setInterval(() => {
                if (this.mapType == 'rawMap' && this.$refs.leafmap && this.$refs.leafgeojson) {
                    this.$refs.leafmap.mapObject.fitBounds(this.$refs.leafgeojson.getBounds());
                    clearInterval(interval)
                } else if (this.mapType == 'interpolatedMap' && this.$refs.leafmap && this.$refs.features) {
                    if (!this.georasterLayer) return null
                    else this.$refs.leafmap.mapObject.fitBounds(this.georasterLayer.getBounds());  
                    clearInterval(interval) 
                }
            }, 50)
        },

        getColor(val, sextiles) { return helpers.getColor(val, sextiles)},
    },
    
}
</script>


<style scoped>
p{
    text-align: center;
}

.row{text-align:center}
</style>